import { render, staticRenderFns } from "./SlideTagMenu.vue?vue&type=template&id=70bccfbf&scoped=true&"
import script from "./SlideTagMenu.vue?vue&type=script&lang=ts&"
export * from "./SlideTagMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SlideTagMenu.vue?vue&type=style&index=0&id=70bccfbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bccfbf",
  null
  
)

export default component.exports